module.exports = __webpack_public_path__ + "ac78bb40280836848b37748427790879.png";